import { AppState } from '~system/store/configure-store';

export const selectIsAuthenticated = (state: AppState) =>
  !!state.auth.accessToken;

export const selectAuth = (state: AppState) => state.auth;
